import React from 'react'
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';


interface IInputProps {
  name: string,
  id: string,
  label: string,
  placeholder?: string,
  readonly?: boolean,
  defaultValue?: string
  disabled?: boolean
  maxLength?: number,
  handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any,
  isvalidateNumber?: boolean,
  isvalidateNumberPostalCode?: boolean,
  req?: string
  resizable?: boolean
  rows?: number
  colums?: number
}
export const TextAreaDefault: React.FC<IInputProps> = ({ name, id, label, placeholder, readonly, defaultValue, disabled, maxLength, req, resizable, rows, colums }) => {

  const { register, formState: { errors } } = useFormContext();
  const errorMessage = get(errors, name)?.message;

  return (
    <>
      <div className={`input-block ${errors && errors[name]?.message ? 'error' : ''}`}>
        <label htmlFor={id} className="input-block__label">{label}</label>
        <textarea
          name={name}
          id={id}
          placeholder={placeholder}
          {...register(name, { required: req })}
          readOnly={readonly || false}
          disabled={disabled || false}
          defaultValue={defaultValue || ''}
          maxLength={maxLength}
          rows={rows}
          autoComplete='off'
          style={{
            resize: resizable ? 'both' : 'none'
          }}
        >

        </textarea>

             {errorMessage && <p className="error m-0">{errorMessage as String}</p>}
      </div>
    </>

  )
}

export default TextAreaDefault;